import React from 'react'
import ErrorImage from "../../assets/img/500 error.gif"
import "./index.scss"

const SomethingWentWrong: React.FC = () => {
  const token = localStorage.getItem("token");
  const profile = localStorage.getItem("profile");

  const handleNavigate = () => {
    if(token || profile) {
      window.location.href = "/dashboard";
      return;
    }
    window.location.href = "/"
  }

  return (
    <div className='something-container'>
        <div className='paper-wrap'>
          <img height={350} width={350} src={ErrorImage} placeholder='500 error image' />
          <h1>Something went wrong</h1>
            <p>The link may be broken or the page may have been removed or renamed</p>
          <button onClick={handleNavigate}>
          <i className="fa fa-arrow-left" aria-hidden="true"></i>
            Go back
            </button>
        </div>
    </div>
  )
}

export default SomethingWentWrong;